export const getAbortSignal = () => {
    const controller = new AbortController();
    const signal = controller.signal;

    return [signal, controller];
}